<template slot="groupTitle">
  <div v-loading="formLoading" class="el-group-title">
    <el-form
      :model="{ extForm }"
      ref="ruleForm"
      label-width="150px"
      class="ccui-form demo-form-inline"
      :inline="true"
    >
      <!--<el-row v-for="item in defaultForm" :key="item.id">
        <el-form-item
          v-if="item.formType === '1'"
          :label="item.titleName + '：'"
          label-width="100px"
        >
          <el-input
            style="width: 436px; height: 85px"
            type="textarea"
            placeholder=""
            v-model="item.formValue"
            maxlength="500"
            show-word-limit
            resize="none"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-else-if="item.formType === '2'"
          :label="item.titleName + '：'"
          label-width="100px"
          class="ccui-form-shenfenzheng"
        >
          <el-row>
            <el-col :span="24">
              <upload
                :obj="item"
                :uploadUrl="item.attribute10"
                @getUrlId="getUrlFr"
              ></upload>
            </el-col>
          </el-row>
        </el-form-item>
      </el-row>-->

      <template v-for="item in dataInfo">
        <el-row :key="item.id">
          <el-form-item
            v-if="item.formType === 1"
            :label="item.titleName + '：'"
            label-width="100px"
            :required="item.attribute2 === '01'"
          >
            <el-input
              style="width: 436px; height: 85px"
              type="textarea"
              placeholder=""
              v-model="item.formValue"
              maxlength="500"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-else-if="item.formType === 2"
            :label="item.titleName + '：'"
            label-width="100px"
            class="ccui-form-shenfenzheng"
            :required="item.attribute2 === '01'"
          >
            <upload
              :obj="item"
              :uploadUrl="item.attribute10"
              @getUrlId="getUrlFr"
              @delFile="delFile"
            ></upload>
            <!-- :uploadUrl="item.attribute10"
              :obj="item"
              @anquan="getUrlTwo" -->
          </el-form-item>
          <el-form-item
            v-else-if="item.formType === 0"
            :label="item.titleName + '：'"
            label-width="100px"
            :required="item.attribute2 === '01'"
          >
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="item.formValue"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-row>
      </template>
      <el-form-item label-width="194px" label="" prop="11">
        <span
          style="color: #0089ef; margin-left: 50px; cursor: pointer"
          @click.stop="downloadEnclosure()"
          >下载承诺书模板</span
        >
      </el-form-item>
      <el-row>
        <el-form-item label-width="100px" label=" ">
          <el-button @click="isFlag()">提交</el-button>
          <el-button class="stopBtn" @click="saveForm()">暂存</el-button>
          <el-button class="lastBtn" @click="lastStep('ruleForm')"
            >上一步</el-button
          >
        </el-form-item>
      </el-row>
    </el-form>
    <el-dialog
      title="是否提交"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      请确认提交，确认提交无法修改，需要修改请走变更
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确 定</el-button>
        <el-button @click="centerDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import upload from "../components/upload2.vue";
import {
  getExtSettingsList,
  getSubconConfigByCode,
  registerSubconChangeInfo,
} from "@/api/subcontractor-register";

export default {
  name: "subconExtInfoChange",
  components: {
    upload,
  },
  props: {
    fifthStepId: "",
    extForm: {
      type: Array,
      default: () => {
        return [];
      },
    },
    extForm1: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    pickerOptions() {
      return {
        disabledDate: function (time) {
          return false;
        },
      };
    },
  },
  data() {
    return {
      formLoading: false,
      centerDialogVisible: false,
      dataInfo: [],
      uploadId: "",
      downloadUrl: this.$addUrlPerFix(
        process.env.VUE_APP_BASE_URL +
          "/apis/sra/reg/users/signup/downloadByUploadId"
      ), //下载文件
      defaultForm: [
        /*{
          formType: "1",
          id: "11111",
          titleName: "名称",
          remark: "请输入",
          formValue: "",
          extSettingId: 11111111
        },
        {
          formType: "2",
          id: "22222",
          titleName: "其他附件",
          remark: "请上传",
          enclosure: "",
          extSettingId: 22121321
        }*/
      ],
    };
  },
  mounted() {
    // 授权书模板id
    getSubconConfigByCode({ configCode: "14" }).then((res) => {
      this.uploadId = res.data.data.configValue;
    });
    getExtSettingsList({}).then((res) => {
      this.dataInfo = res.data.data;
      this.defaultForm.forEach((e) => {
        const tmp = this.getFormValue(e.extSettingId);
        if (tmp) {
          e.formValue = tmp.formValue;
          e.enclosure = tmp.enclosure;
          e.attribute10 = tmp.attribute10;
        }
      });
      this.dataInfo.forEach((e) => {
        const tmp = this.getFormValue(e.id);
        if (tmp) {
          this.$set(e, "formValue", tmp.formValue);
          this.$set(e, "enclosure", tmp.enclosure);
          this.$set(e, "attribute10", tmp.attribute10);
        }
      });
    });
  },
  methods: {
    getFormValue(id) {
      for (var i = 0; i < this.extForm.length; i++) {
        if (id === this.extForm[i].extSettingId) {
          return this.extForm[i];
        }
      }
    },
    getUrlFr(url, obj) {
      this.$set(obj, "enclosure", url);
      this.$set(obj, "attribute10", url);
    },
    downloadEnclosure(uploadId) {
      /*window.open(
        `${this.downloadUrl}?uploadId=${this.uploadId}&agentId=${getArgs("a")}`
      );*/
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${this.downloadUrl}?uploadId=` + this.uploadId; //4106
      openUrl.setAttribute("download", "承诺书");
      //document.body.appendChild(openUrl);
      //openUrl.click();
      console.log(openUrl);
      window.open(openUrl);
    },
    /*download() {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${this.downloadUrl}?uploadId=` + this.uploadId; //4106
      openUrl.setAttribute("download", "承诺书");
      document.body.appendChild(openUrl);
      openUrl.click();
    },*/
    // 获取事件
    getDate(dateData) {
      let date = new Date(dateData);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    },
    submit() {
      this.centerDialogVisible = false;
      this.submitForm("ruleForm");
    },
    isFlag() {
      this.centerDialogVisible = true;
    },
    saveForm() {
      if (this.dataInfo && this.dataInfo.length > 0) {
        this.dataInfo.forEach((e) => {
          if ((e.formType === "0" || e.formType === 0) && e.formValue) {
            try {
              e.formValue = this.getDate(e.formValue);
            } catch (e) {
              e.formValue = "";
              console.log(e);
            }
          } else {
            e.formValue = "";
          }
          e.extSettingId = e.id;
        });
      }
      const tmp = [...this.defaultForm, ...this.dataInfo];
      const tmpArr = [];
      tmp.forEach((e) => {
        var item = Object.assign({}, e);
        if ((item.formType === "2" || item.formType === 2) && item.enclosure) {
          item.enclosure = item.enclosure.uploadId;
          item.attribute10 = "";
        } else {
          item.enclosure = "";
          item.attribute10 = "";
        }
        tmpArr.push(item);
      });

      this.formLoading = true;
      registerSubconChangeInfo({
        subconChangeInfo: {
          id: this.fifthStepId,
          country: this.extForm1.country,
          province: this.extForm1.province,
          city: this.extForm1.city,
          county: this.extForm1.county,
          attribute2: this.extForm1.attribute2,
        },
        subconExtInfoChange: tmpArr,
      }).then(
        (res) => {
          this.formLoading = false;
          if (res.data.data.code === "0") {
            this.extForm = Object.assign(this.extForm, tmp);
            this.$message({
              showClose: true,
              type: "success",
              message: "暂存成功",
              ccuiCustom: true,
            });
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.data.message,
              ccuiCustom: true,
            });
          }
        },
        (error) => {
          this.formLoading = false;
        }
      );
    },
    logCon(item) {
      this.$message({
        showClose: true,
        type: "error",
        message: item.titleName + "必填",
        ccuiCustom: true,
      });
    },
    delFile(item) {
      /*for (var i = 0; i < this.dataInfo.length; i++) {
            this.dataInfo[i].
        }*/
      this.dataInfo.forEach((e) => {
        if (e.extSettingId === item.extSettingId) {
          this.$set(e, "formValue", "");
          this.$set(e, "enclosure", "");
          this.$set(e, "attribute10", "");
        }
      });
    },
    submitForm(formName) {
      var that = this;
      if (this.dataInfo && this.dataInfo.length > 0) {
        this.dataInfo.forEach((e) => {
          if ((e.formType === "0" || e.formType === 0) && e.formValue) {
            try {
              e.formValue = this.getDate(e.formValue);
            } catch (e) {
              e.formValue = "";
              console.log(e);
            }
          } else {
            e.formValue = "";
          }
          e.extSettingId = e.id;
        });
      }
      const tmp = [...this.defaultForm, ...this.dataInfo];
      for (var i = 0; i < tmp.length; i++) {
        if (tmp[i].attribute2 === "01") {
          if (tmp[i].formType === "2" || tmp[i].formType === 2) {
            if (!tmp[i].enclosure || !tmp[i].enclosure.uploadId) {
              this.logCon(tmp[i]);
              return false;
            }
          } else {
            if (!tmp[i].formValue) {
              this.logCon(tmp[i]);
              return false;
            }
          }
        }
      }
      // debugger;
      const tmpArr = [];
      tmp.forEach((e) => {
        var item = Object.assign({}, e);
        if ((item.formType === "2" || item.formType === 2) && item.enclosure) {
          item.enclosure = item.enclosure.uploadId;
          item.attribute10 = "";
        } else {
          item.enclosure = "";
          item.attribute10 = "";
        }
        tmpArr.push(item);
      });
      this.formLoading = true;
      registerSubconChangeInfo({
        subconChangeInfo: {
          id: this.fifthStepId,
          subconAuditStatus: 1,
          registeredType: 0,
          checkState: 1,
          country: this.extForm1.country,
          province: this.extForm1.province,
          city: this.extForm1.city,
          county: this.extForm1.county,
          attribute2: this.extForm1.attribute2,
        },
        subconExtInfoChange: tmpArr,
      }).then(
        (res) => {
          this.formLoading = false;
          let { code, message } = res.data.data;
          if (code === "0") {
            this.$router.push("/subcon-submit-success");
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: message,
              ccuiCustom: true,
            });
          }
        },
        (error) => {
          this.formLoading = false;
        }
      );
    },
    lastStep() {
      this.$emit("getStep", 3);
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-form {
  // display:flex;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;
  transform: translate(120px, 0px);
}
// /deep/.el-form>div{
//   max-width:450px;
// }
.el-group-title {
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
  /deep/.avatar-uploader {
    border: 1px dashed rgba(248, 82, 109, 1);
    background: rgba(248, 82, 109, 0.05);
    border-radius: 5px;
  }
  /deep/.avatar-uploader .el-upload {
    border: none;
    color: rgba(248, 82, 109, 1) !important;
    display: flex;
    justify-content: center;
    align-items: center;
    .tip {
      margin-top: 35px;
      width: 150px;
      height: 50px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff152e;
      span {
        position: relative;
        top: 5px;
        font-size: 40px;
        margin-right: 10px;
        display: inline-block;
        width: 32px;
        height: 32px;
        text-align: center;
        line-height: 25px;
        border: 2px solid rgba(248, 82, 109, 1) !important;
        border-radius: 50%;
      }
    }
  }
}
.el-button {
  width: 82px;
  height: 40px;
  background: #ff152e;
  border-radius: 2px;
  font-size: 14px;
  border: none;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.el-form-item__content .stopBtn {
  background: rgba(255, 21, 46, 0.08);
  border: 1px solid #ff152e;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff152e;
}
.el-form-item__content .el-textarea,
.el-form-item__content .el-textarea /deep/.el-textarea__inner {
  width: 434px;
  overflow: hidden;
}
.el-form-item__content .lastBtn {
  background: #fafafa;
  border: 1px solid #dddddd;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.25);
}
.el-form-item /deep/.el-form-item__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
}
.el-icon-plus avatar-uploader-icon {
  width: 100%;
  height: 100%;
}
</style>
